// CAPABILITY: Single chat message row — bubble with the name underneath. Plain text only.
import React from "react";

const NAME_COLORS = [
  "#dc2626", "#ea580c", "#b45309", "#15803d",
  "#0d9488", "#2563eb", "#7c3aed", "#be185d",
];

function colorForName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return NAME_COLORS[hash % NAME_COLORS.length];
}

function formatTime(ts) {
  try {
    const d = ts && typeof ts.toDate === "function" ? ts.toDate() : null;
    return d ? d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "";
  } catch (_error) {
    return "";
  }
}

export default function ChatMessage({ message, isOwn, accentColor, accentText }) {
  const name = message.display_name || "Guest";
  const color = colorForName(name);
  const time = formatTime(message.created_at);

  return (
    <div className={`flex flex-col px-3 py-1 ${isOwn ? "items-end" : "items-start"}`}>
      <div
        className={`max-w-[85%] whitespace-pre-wrap break-words rounded-md px-3 py-1.5 text-sm leading-snug ${
          isOwn ? "" : "bg-white text-slate-800 ring-1 ring-slate-200"
        }`}
        style={isOwn ? { backgroundColor: accentColor || "#0f172a", color: accentText || "#ffffff" } : undefined}
      >
        {message.text}
      </div>

      <div className={`mt-1 flex items-center gap-1.5 px-1 text-[11px] ${isOwn ? "flex-row-reverse" : ""}`}>
        <span className="max-w-[170px] truncate font-semibold" style={{ color: isOwn ? "#64748b" : color }}>
          {isOwn ? "You" : name}
        </span>
        {time && <span className="text-slate-400">{time}</span>}
      </div>
    </div>
  );
}
